export default __webpack_public_path__ + "static/media/wecycle-logo.1e3adee9.jpg";